// extracted by mini-css-extract-plugin
export default {"user-form":"UserForm_user-form__m6l3G"};